import { ComplexValue } from 'app/infrastructure/ui/form/types';
import { Value } from 'app/types-shared';
import { ValidationProps } from 'ui/common/validation/types';
import { ExtraInfoValue } from 'app/components/access-panel/extra-info/types';
import { DefaultValue } from 'app/components/access-panel/default-values/panel-default-values-utils';
import { SingleOptionPanelSelectedValue } from 'app/components/access-panel/options-panel/types';

export interface OperationEndpoints {
  applications?: string;
  operations?: (id: number) => string;
  accesstoscreen?: { caseType: string; screen: (id: number) => string };
  extendedAccess?: { caseType: string; unit: (id: number) => string };
  responsibleForUnit?: { caseType: string; unit: (id: number) => string };
  restrictedAccess?: { caseType: string; unit: (id: number) => string };
  defaultValues?: {
    optionsCollections: string;
    caseTypes: string;
    values: (id: number) => string;
    valuesFields: (id: number) => string;
  };
  accessToUserGroups?: string;
  personExcluded?: string;
  extraInfo?: string;
  extraInfoOptions?: (extraInfoId: number) => string;
  role?: string;
  subscriptionOptions?: string;
}

export type AccessPanelData = {
  [key: string]: AccessItem;
};

export interface AccessPanelDataValidation {
  [key: string]: ValidationProps;
}

export interface AlternativeIdData {
  personId: string;
  name: string;
}

export interface AccessPerson {
  id: number;
  delete: boolean;
  edit: boolean;
  dbAccess: {
    add: boolean;
    edit: boolean;
    delete: boolean;
  };
}

export interface DefaultValueReturnType {
  codeTable: Value;
  caseType: Value;
  defaultValue: Value;
  field: Value;
}

export interface ExtraInfoWireFormat {
  extraInfo: Value;
  valueString?: string;
  valueInteger?: number;
  valueFloat?: number;
  valueDate?: string;
  valueCode?: Value;
}

export interface Person {
  id: number;
  personId?: string;
  name?: string;

  created: string;
  modified: string;
  createdBy: Value;
  modifiedBy: Value;

  accessOperations?: { operation: Value; application: Value }[];
  accessToScreen?: { domainNode: Value; application: Value }[];
  accessToUserGroups?: Value[];
  defaultValues?: DefaultValueReturnType[];
  extendedAccess?: { unit: Value; application: Value }[];
  responsibleForUnits?: any;
  personExcluded?: Value[];
  restrictedAccess?: any[];
  accessToAssignRoles?: Value[];
  additionalInformation: ExtraInfoWireFormat[];
  experienceTransferAlerts?: Value[];
}

export interface ChangeWire {
  date: string;
  author: string;
}

export interface UserWireData extends Person {
  emailAddress: string;
  latestLogin: string;
  disabled: string;
  userType: Value;
  mainUserGroup: Value;
  currentUserGroup: Value;
  unit: Value;
  location: Value;
  language: Value;
  accessRole: Value;
}

export enum AccessMode {
  role = 1,
  custom
}

export interface CustomData {
  selectedOptions?: ComplexValue<number>[];
  selectedValues?: { [key: number]: SingleOptionPanelSelectedValue[] } | SingleOptionPanelSelectedValue[];
  initialValues?: { [key: string]: ComplexValue<number> };
  values?: DefaultValue[];
  extraInfo?: ExtraInfoValue[];
}

export interface AccessItem {
  mode: AccessMode;
  customData?: CustomData;
  roleBaseData: any;
}

export interface User extends Person {
  emailAddress: string;
  latestLogin: string;
  latestActivity: string;
  disabled: string;
  userType: ComplexValue<number>;
  mainUserGroup: ComplexValue<number>;
  currentUserGroup: ComplexValue<number>;
  unit: ComplexValue<number>;
  location: ComplexValue<number>;
  language: ComplexValue<number>;
  accessRole: ComplexValue<number>;
  alternativeIds: AlternativeIdData[];
  technical: boolean;
}

export interface PersonOptionsCodes {
  fetching: boolean;
  values: Value[];
}

export interface UserOptions {
  fetching: boolean;
  values: ComplexValue<number>[];
}

export interface ExtraInfoCodeValues {
  id: number;
  description: string;
  extraInfoDataType: ExtraInfoType;
  searchRequired: boolean;
  category: number;
  isHierarchy: boolean;
}

export interface ExtraInfoCodes {
  fetching: boolean;
  values: ExtraInfoCodeValues[];
}

export interface UserDefaultValues {
  defaultValues?: DefaultValueReturnType[];
}

export enum ExtraInfoType {
  unknown = -1,
  text = 1,
  date = 2,
  integer = 3,
  float = 4,
  singleSelect = 5,
  multiSelect = 6
}
